import React, { useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import { IWorkOrderMapObject } from "../../../apis/OcpwAssetworks/OcpwAssetworksApi";

interface AttachDocumentsFormProps {
  open: boolean;
  onClose: () => void;
 setDtoPreview:any
 tabIndex:any;
 pageIndexes:any
}

const AttachDocumentsForm: React.FC<AttachDocumentsFormProps> = ({
  open,
  onClose,
  setDtoPreview,
  tabIndex,
  pageIndexes
}) => {
  const [files, setFiles] = useState<File[]>([]);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFiles = (fileList: FileList | null) => {
    if (!fileList) return;
    const newFiles = Array.from(fileList);
    setFiles((prev) => [...prev, ...newFiles]);
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    handleFiles(event.dataTransfer.files);
  };

  const handleRemove = (index: number) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleUpload = () => {
  setDtoPreview((prev: IWorkOrderMapObject[][]) =>
    prev.map((layer, tIdx) =>
      tIdx === tabIndex
        ? layer.map((wo, pIdx) => {
            if (pIdx === pageIndexes[tabIndex]) {
              // If attachFiles exists and is an array, append new files
              if (Array.isArray(wo.attachFiles)) {
                return { ...wo, attachFiles: [...wo.attachFiles, ...files] };
              }
              // Otherwise, create a new attachFiles array
              return { ...wo, attachFiles: [...files] };
            }
            return wo;
          })
        : layer
    )
  );
  setFiles([]);
  onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Attach Documents</DialogTitle>
      <DialogContent>
        <Box
          onDrop={handleDrop}
          onDragOver={(e) => e.preventDefault()}
          sx={{
            border: "2px dashed #90caf9",
            borderRadius: 2,
            p: 3,
            textAlign: "center",
            background: "#f5f7fa",
            mb: 2,
            cursor: "pointer",
          }}
          onClick={() => fileInputRef.current?.click()}
        >
          <CloudUploadIcon sx={{ fontSize: 40, color: "#90caf9" }} />
          <Typography variant="body1" sx={{ mt: 1 }}>
            Drag and drop files here, or click to select files
          </Typography>
          <input
            ref={fileInputRef}
            type="file"
            multiple
            hidden
            onChange={(e) => handleFiles(e.target.files)}
          />
        </Box>
        <List dense>
          {files.map((file, idx) => (
            <ListItem key={idx}>
              <ListItemText primary={file.name} secondary={`${(file.size / 1024).toFixed(1)} KB`} />
              <ListItemSecondaryAction>
                <IconButton edge="end" onClick={() => handleRemove(idx)}>
                  <DeleteIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
        {files.length === 0 && (
          <Typography variant="body2" color="text.secondary" align="center">
            No files selected.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleUpload}
          color="primary"
          variant="contained"
          disabled={files.length === 0}
        >
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AttachDocumentsForm;